import { useDisclosure } from '@mantine/hooks'
import React, { useEffect, useState } from 'react'
import { Image } from 'react-bootstrap'
import { connect, useDispatch, useSelector } from 'react-redux'

import ColetaClickstream from '../../../components/clickstreamAnalise/clickstreamColeta.js'
import { api_gateway } from '../../../conexoes/api'
import {
  desabilitarAcoes,
  limpadorFiltros,
  limpouBusca,
  mudarFiltros,
  mudarManejador,
  mudarOrdenador,
  realizouBusca,
  realizouFiltro,
  revelarBarraFiltragem,
  revelarExcluirPlano
} from '../../../redux/actions/index'
import { useGlobal } from '../../../stores/useGlobal'
import { setaDropdown } from '../../../utils/alternanciaIcones'
import decryptJWT from '../../../utils/decryptJWT'
import { formatarMilhar } from '../../../utils/formatarMilhar'
import MensagemAtencao from '../../componentesModais/mensagens/mensagemAtencao'
import MensagemErro from '../../componentesModais/mensagens/mensagemErro'
import MensagemSucesso from '../../componentesModais/mensagens/mensagemSucesso'

import Alerta from './Alerta'
import CadastroPlano from './cadastro'
import DetalhamentoPlano from './detalhamento'

import '../../../css/painelFaturas/fatPlanos/fatPlanos.css'
import Table from '../../Table/index.jsx'

let contador = 0
let controladorPagina = 1
let totalPaginas = 0
let totalItens = 0
const valorLimite = 50

const TableprimaryKey = 'cd_fat_plano'

function TabelaPlanos() {
  const { setIsLoadingGlobal } = useGlobal()
  const [itens, setItens] = useState([])
  const [paginaAtual, setPaginaAtual] = useState(1)
  const [renderizar, setRenderizar] = useState(false)
  const [cdPlano, setCdPlano] = useState()
  const [dsNomePlano, setDsNomePlano] = useState()
  const [n0Simcards, setN0Simcards] = useState()

  const [mensagemErro, setMensagemErro] = useState(
    'Ocorreu um erro ao executar esta ação'
  )

  const [message, setMessage] = useState('')
  const [revelarMensagemErro, setRevelarMensagemErro] = useState(false)
  const [revelarMensagemSucesso, setRevelarMensagemSucesso] = useState(false)
  const [openedAlerta, { open: openAlerta, close: closeAlerta }] =
    useDisclosure(false)
  const [itensSelecionados, setItensSelecionados] = useState([])

  const despacho = useDispatch()
  let revelarBarraFiltro = useSelector(
    (state) => state.filtrosState.revelarBarraFiltragem
  )
  let conteudoBusca = useSelector((state) => state.manejadorState.conteudoBusca)
  let limpouBuscaGeral = useSelector(
    (state) => state.manejadorState.limpouBusca
  )
  let estadoExpansaoMenu = useSelector(
    (state) => state.manejadorState.expandirNavegacao
  )
  let realizouBuscaGeral = useSelector(
    (state) => state.manejadorState.realizouBusca
  )
  let filtros = useSelector((state) => state.filtrosState.filtros)

  let realizouFiltragem = useSelector(
    (state) => state.manejadorState.realizouFiltro
  )
  let NovoPlano = useSelector((state) => state.faturasState.revelarNovoPlano)
  let editarPlano = useSelector(
    (state) => state.faturasState.revelarEditarPlano
  )
  let ordenador = useSelector((state) => state.manejadorState.ordenador)
  let excluirPlano = useSelector(
    (state) => state.faturasState.revelarExcluirPlano
  )

  const cd_pav_usuario = decryptJWT('codigo')
  let itensVar = []
  const [coletaUsabilidade, setColetaUsabilidade] = useState(true)

  useEffect(() => {
    if (coletaUsabilidade) {
      ColetaClickstream(635) // 'fatPlanosTabela'
      setColetaUsabilidade(false)
    }
  }, [])

  useEffect(() => {
    despacho(revelarBarraFiltragem(false))
    if (!filtros.vazio) {
      despacho(mudarFiltros({ vazio: 'vazio' }))
    }
    despacho(limpadorFiltros(true))
  }, [])

  useEffect(() => {
    setIsLoadingGlobal(true)
    despacho(mudarManejador('faturasPlanos'))
    despacho(desabilitarAcoes(true))
    async function carregarTabela() {
      //clicou no botão de limpar a busca geral e retorna tudo ao estado original
      if (limpouBuscaGeral) {
        despacho(limpouBusca(false))
        restaurarConfigsIniciaisPagina()
      }

      //clicou no botão de busca geral
      if (realizouBuscaGeral) {
        despacho(realizouBusca(false))
        restaurarConfigsIniciaisPagina()
      }

      //clicou no botão para filtro
      if (realizouFiltragem) {
        despacho(realizouFiltro(false))
        restaurarConfigsIniciaisPagina()
      }

      if (ordenador) {
        restaurarConfigsIniciaisPagina()
      }

      if (conteudoBusca && filtros.vazio) {
        if (totalPaginas == 0) {
          contador = 0
          itensVar = []
          setItens([])
          await contarItens()
        } else {
          contador = (paginaAtual - 1) * valorLimite
        }
        if (controladorPagina <= paginaAtual) {
          await contarItens()
          const queryString =
            'paginaAtual=' +
            contador +
            '&carregarLimit=' +
            valorLimite +
            '&buscar=' +
            conteudoBusca +
            '&ordenador=' +
            ordenador +
            '&cd_pav_usuario=' +
            cd_pav_usuario
          const { data } = await api_gateway.get(
            '/m1/consultar/fat_plano?' + queryString
          )
          inserirData(data.dados)
        }
      } else if (!filtros.vazio) {
        if (totalPaginas == 0) {
          contador = 0
          itensVar = []
          setItens([])
          await contarItens()
        } else {
          contador = (paginaAtual - 1) * valorLimite
        }
        const dados = {
          paguinaAtual: contador,
          carregarLimit: valorLimite,
          buscar: conteudoBusca,
          filtros: filtros,
          ordenador: ordenador,
          cd_pav_usuario: cd_pav_usuario
        }
        if (controladorPagina <= paginaAtual) {
          const { data } = await api_gateway.post(
            '/m1/filtrar/fat_plano',
            dados
          )
          inserirData(data.dados)
        }
      } else {
        if (totalPaginas == 0) {
          await contarItens()
        } else {
          contador = (paginaAtual - 1) * valorLimite
        }
        if (controladorPagina <= paginaAtual) {
          const { data } = await api_gateway.get(
            '/m1/consultar/fat_plano?paginaAtual=' +
              contador +
              '&ordenador=' +
              ordenador +
              '&carregarLimit=' +
              valorLimite +
              '&cd_pav_usuario=' +
              cd_pav_usuario
          )
          inserirData(data.dados)
        }
      }
      setIsLoadingGlobal(false)
    }
    carregarTabela()
  }, [paginaAtual, conteudoBusca, renderizar, filtros, ordenador])

  function inserirData(data) {
    for (let i = 0; i < totalItens; i++) {
      if (contador === i) {
        let k = i
        for (let j = 0; j < data.length; j++) {
          itensVar[k] = data[j]
          k++
        }
      }
      if (i == totalItens - 1) {
        setItens(JSON.parse(JSON.stringify(itensVar)))
      }
    }
  }

  async function contarItens() {
    let arrayItens = []
    let apiData = []
    if (controladorPagina <= paginaAtual) {
      if (controladorPagina <= paginaAtual && filtros.vazio) {
        apiData = await api_gateway.get(
          '/m1/consultar/fat_plano?contar=true&buscar=' +
            conteudoBusca +
            '&ordenador=' +
            ordenador +
            '&cd_pav_usuario=' +
            cd_pav_usuario
        )
      } else {
        const dados = {
          paguinaAtual: contador,
          carregarLimit: valorLimite,
          buscar: conteudoBusca,
          filtros: filtros,
          contar: true,
          ordenador: ordenador,
          cd_pav_usuario: cd_pav_usuario
        }
        apiData = await api_gateway.post('/m1/filtrar/fat_plano', dados)
      }
      itensVar = []
      if (apiData.data.dados) {
        totalPaginas = Math.ceil(apiData.data.dados[0].CONTADOR / valorLimite)
        totalItens = apiData.data.dados[0].CONTADOR
        for (var i = 0; i < apiData.data.dados[0].CONTADOR; i++) {
          arrayItens.push(i)
        }
        itensVar = arrayItens
      }
    }
  }

  function restaurarConfigsIniciaisPagina() {
    totalPaginas = 0
    contador = 0
    controladorPagina = 1
    totalItens = 0
    setPaginaAtual(1)
  }

  const colunas = [
    {
      dataField: 'cd_fat_plano',
      text: (
        <button
          className="btn-header-nome fonte-cor-1"
          onClick={() => handlerOrdenador('cd_fat_plano', 'cd_fat_plano')}
        >
          Cód. plano
          <Image
            id="cd_fat_planocd_fat_plano"
            className="d-none"
            src={setaDropdown()}
          />
        </button>
      ),
      headerClasses: 'nao-selecionavel',
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell || '-'}</p>
      }
    },
    {
      dataField: 'ds_plano',
      headerClasses: 'nao-selecionavel',
      text: (
        <button
          className="btn-header-nome fonte-cor-1"
          onClick={() => handlerOrdenador('ds_plano', 'ds_plano')}
        >
          Nome do plano
          <Image
            id="ds_planods_plano"
            className="d-none"
            src={setaDropdown()}
          />
        </button>
      ),
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell || '-'}</p>
      }
    },
    {
      dataField: 'ds_apelido',
      headerClasses: 'nao-selecionavel',
      text: (
        <button
          className="btn-header-nome fonte-cor-1"
          onClick={() => handlerOrdenador('ds_apelido', 'ds_apelido')}
        >
          Operadora
          <Image
            id="ds_apelidods_apelido"
            className="d-none"
            src={setaDropdown()}
          />
        </button>
      ),
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell || '-'}</p>
      }
    },
    {
      dataField: 'ds_fat_nome_fantasia',
      headerClasses: 'nao-selecionavel',
      text: (
        <button
          className="btn-header-nome fonte-cor-1"
          onClick={() =>
            handlerOrdenador('ds_fat_fornecedor', 'ds_fat_fornecedor')
          }
        >
          Fornecedor
          <Image
            id="ds_fat_fornecedords_fat_fornecedor"
            className="d-none"
            src={setaDropdown()}
          />
        </button>
      ),
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell || '-'}</p>
      }
    },
    {
      dataField: 'n2_valor_plano',
      headerClasses: 'nao-selecionavel',
      text: (
        <button
          className="btn-header-nome fonte-cor-1"
          onClick={() => handlerOrdenador('n2_valor_plano', 'n2_valor_plano')}
        >
          Valor
          <Image
            id="n2_valor_planon2_valor_plano"
            className="d-none"
            src={setaDropdown()}
          />
        </button>
      ),
      sort: true,
      formatter: (cell) => {
        return (
          <p className="fonte-cor-1 label-tabela-1">
            R$ {cell ? formatarMilhar(cell) : '0.00'}
          </p>
        )
      }
    },
    {
      dataField: 'n0_simcards',
      headerClasses: 'nao-selecionavel',
      text: (
        <button
          className="btn-header-nome fonte-cor-1"
          onClick={() => handlerOrdenador('n0_simcards', 'n0_simcards')}
        >
          Número de SIM cards
          <Image
            id="n0_simcardsn0_simcards"
            className="d-none"
            src={setaDropdown()}
          />
        </button>
      ),
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell || '-'}</p>
      }
    }
  ]

  function handlerDesativarImagens(imagem, terminacao) {
    const elementosAtivosDESC = document.querySelectorAll(
      '.icone-ordenacao-DESC'
    )
    const elementosAtivosASC = document.querySelectorAll('.icone-ordenacao-ASC')
    elementosAtivosDESC.forEach((el) => el.classList.add('d-none'))
    elementosAtivosASC.forEach((el) => el.classList.add('d-none'))
    elementosAtivosDESC.forEach((el) =>
      el.classList.remove('icone-ordenacao-DESC')
    )
    elementosAtivosASC.forEach((el) =>
      el.classList.remove('icone-ordenacao-ASC')
    )

    imagem.classList.remove('d-none')
    imagem.classList.add('icone-ordenacao-' + terminacao)
  }

  function handleRemoverImagens(imagem) {
    const elementosAtivosDESC = document.querySelectorAll(
      '.icone-ordenacao-DESC'
    )
    const elementosAtivosASC = document.querySelectorAll('.icone-ordenacao-ASC')
    elementosAtivosDESC.forEach((el) => el.classList.add('d-none'))
    elementosAtivosASC.forEach((el) => el.classList.add('d-none'))
    elementosAtivosDESC.forEach((el) =>
      el.classList.remove('icone-ordenacao-DESC')
    )
    elementosAtivosDESC.forEach((el) =>
      el.classList.remove('icone-ordenacao-ASC')
    )
    elementosAtivosASC.forEach((el) =>
      el.classList.remove('icone-ordenacao-ASC')
    )
    elementosAtivosASC.forEach((el) =>
      el.classList.remove('icone-ordenacao-DESC')
    )
    imagem.classList.remove('icone-ordenacao-ASC')
    imagem.classList.remove('icone-ordenacao-DESC')
  }

  async function handlerOrdenador(nomeOrdenador, nomeDiferenciado) {
    let isItDescrescente = false
    const imagem = document.getElementById(nomeOrdenador + nomeDiferenciado)
    //verifica esta mudando a forma de ordenacao no mesmo elemento
    if (
      nomeOrdenador === ordenador.split(' ASC')[0] ||
      nomeOrdenador === ordenador.split(' DESC')[0]
    ) {
      await ordenador.split(' ').map((item_ordenador) => {
        //verifica se existe tal item e muda para decrescente
        if (item_ordenador === 'ASC') {
          //Sera tal ordenador para decrescente
          ordenador = nomeOrdenador + ' DESC'
          isItDescrescente = true
          //transforma a imagem para o modo DESC ao qual mosta a imagem normalmente e faz a limpeza dos outros icones
          handlerDesativarImagens(imagem, 'ASC')
        }
        if (item_ordenador === 'DESC') {
          //Sera tal ordenador para crescente
          ordenador = ''
          isItDescrescente = false
          //transforma a imagem para o modo ASC ao qual mosta a imagem rotacionada 180deg e faz a limpeza dos outros icones
          handleRemoverImagens(imagem)
        }
      })
    } else if (!isItDescrescente) {
      ordenador = nomeOrdenador + ' ASC'
      //Adicaiona a classe de crescente para a imagem e faz a limpeza dos outros icones
      handlerDesativarImagens(imagem, 'DESC')
    }
    despacho(mudarOrdenador(JSON.parse(JSON.stringify(ordenador))))
  }

  async function handleDeletar() {
    ColetaClickstream(645) // 'fatPlanosTabelaDropAcoesExcluirPlanoExcluir'
    setIsLoadingGlobal(true)
    await api_gateway
      .get(
        '/m1/deletar/fat_plano?cd_fat_plano=' +
          cdPlano +
          '&cd_pav_usuario=' +
          decryptJWT('codigo')
      )
      .then(function (response) {
        if (response.data.status === 600) {
          openAlerta()
          setMessage(response.data?.info)
          despacho(revelarExcluirPlano(false))
        } else {
          despacho(revelarExcluirPlano(false))
          handleMensagemSucesso(false)
          setRenderizar(!renderizar)
        }
      })
      .catch(function (error) {
        setMensagemErro(error.response.data.info)
        handleMensagemErro(false)
      })
      .finally(() => {
        setIsLoadingGlobal(false)
      })
  }

  function handleMensagemAtencao(confirmacao) {
    ColetaClickstream(646) // 'fatPlanosTabelaDropAcoesExcluirPlanoCancelar'
    if (confirmacao === true) {
      handleDeletar()
    } else {
      despacho(revelarExcluirPlano(false))
    }
  }

  const deletePlan = async () => {
    setIsLoadingGlobal(true)
    await api_gateway
      .get(
        '/m1/deletar/fat_plano?cd_fat_plano=' +
          cdPlano +
          '&fl_delete_with_simcard=1&cd_pav_usuario=' +
          decryptJWT('codigo')
      )
      .then(function () {
        setRenderizar(!renderizar)
      })
      .catch(function (error) {
        setMensagemErro(error.response.data.info)
        handleMensagemErro(false)
      })
      .finally(() => {
        setIsLoadingGlobal(false)
        closeAlerta()
      })
  }

  function handleMensagemErro() {
    if (revelarMensagemErro === false) setRevelarMensagemErro(true)
    else setRevelarMensagemErro(false)
  }

  function handleMensagemSucesso() {
    if (revelarMensagemSucesso === false) setRevelarMensagemSucesso(true)
    else setRevelarMensagemSucesso(false)
  }

  const renderDetalhamentoLinha = (row) => {
    return (
      <div
        className={
          estadoExpansaoMenu === true
            ? 'expand-row-tabela-planos-faturas-1'
            : 'expand-row-tabela-planos-faturas-2'
        }
      >
        <DetalhamentoPlano cdPlano={row.cd_fat_plano} fatura={row} />
      </div>
    )
  }

  const handleOnSelect = (row, isSelect) => {
    if (isSelect) {
      setItensSelecionados(row)

      if (isSelect) {
        setCdPlano(row.cd_fat_plano)
        setDsNomePlano(row.ds_plano)
        setN0Simcards(row.n0_simcards)
        despacho(desabilitarAcoes(false))
      }
    }
  }

  const getLimiteNaPagina = () =>
    contador + valorLimite <= totalItens ? contador + valorLimite : totalItens
  const getTotalItensNaPagina = () => getLimiteNaPagina()

  const trocarPagina = (novaPagina) => {
    if (totalPaginas <= 1) return

    setPaginaAtual(novaPagina)
  }

  const itensSelecionadosTable = itensSelecionados?.[TableprimaryKey]
    ? [itensSelecionados[TableprimaryKey]]
    : []

  return (
    <div className="container-tela">
      <Table
        keyField={TableprimaryKey}
        clickToSelect
        revelarContador
        itens={itens}
        colunas={colunas}
        revelarBarraFiltro={revelarBarraFiltro}
        permissaoDetalhamentoLinha
        detalhamentLinha={renderDetalhamentoLinha}
        getTotalItensNaPagina={getTotalItensNaPagina}
        getLimiteNaPagina={getTotalItensNaPagina}
        pagination={{
          paginaAtual,
          valorLimite,
          totalPaginas,
          totalItens,
          contador,
          trocarPagina
        }}
        selection={{
          itensSelecionados: itensSelecionadosTable,
          modeSelection: 'radio',
          handleOnSelect
        }}
      />

      {NovoPlano === true && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <CadastroPlano
              tituloJanela="Cadastrar"
              renderizar={renderizar}
              setRenderizar={setRenderizar}
            />
          </div>
        </div>
      )}
      {editarPlano === true && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <CadastroPlano
              tituloJanela="Editar"
              renderizar={renderizar}
              setRenderizar={setRenderizar}
              cdPlano={cdPlano}
              dsNomePlano={dsNomePlano}
              n0Simcards={n0Simcards}
            />
          </div>
        </div>
      )}
      {revelarMensagemSucesso && (
        <MensagemSucesso
          handleMensagemSucesso={handleMensagemSucesso}
          mensagemTitulo="Sucesso"
          mensagemParagrafo1={'Plano ' + dsNomePlano + ' excluído.'}
          mensagemBotao="Continuar"
        />
      )}
      {excluirPlano && (
        <MensagemAtencao
          handleMensagemAtencao={handleMensagemAtencao}
          mensagemTitulo="Excluir plano"
          mensagemParagrafo1={
            'Tem certeza que deseja excluir o plano ' + dsNomePlano + '?'
          }
          mensagemBotao="Excluir"
        />
      )}
      {revelarMensagemErro && (
        <MensagemErro
          handleMensagemErro={handleMensagemErro}
          mensagemTitulo={mensagemErro}
          mensagemParagrafo1="Erro"
          mensagemParagrafo2={mensagemErro}
          mensagemBotao="Retornar"
        />
      )}
      {openedAlerta && (
        <Alerta
          opened={openedAlerta}
          onClose={closeAlerta}
          onClick={deletePlan}
          message={message}
        />
      )}
    </div>
  )
}

function mapStateToProps(state) {
  return {
    conteudoBusca: state.manejadorState.conteudoBusca,
    filtros: state.filtrosState.filtros
  }
}
//React.memo - nao permitir a renderizacao se o state e o props nao mudarem de estado
export default connect(mapStateToProps)(React.memo(TabelaPlanos))
